import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetCountries } from "../../redux/slices.js/tenants/tenantsSlice";

const industries = [
  { value: "Technology", label: "Technology" },
  { value: "Health care", label: "Health care" },
  { value: "Finance", label: "Finance" },
  { value: "Retail", label: "Retail" },
  { value: "Education", label: "Education" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Hospitality", label: "Hospitality" },
];

const countries = [
  { value: "united-states", label: "United States" },
  { value: "united-kingdom", label: "United Kingdom" },
  { value: "australia", label: "Australia" },
  { value: "canada", label: "Canada" },
  { value: "new-zealand", label: "New Zealand" },
];

const CompanyInfo = () => {
  const dispatch = useDispatch();

  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    useFormikContext();
  const { countries, countriesLoader } = useSelector((state) => state.tenants);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        reqToGetCountries({
          search: searchTerm,
          onSuccess: () => {},
          onFailure: (err) => console.error(err),
        })
      );
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm, dispatch]);

  const countryOptions =
    countries?.map((c) => ({
      value: c.id, // id from API
      label: c.name, // name from API
    })) || [];

  const handleCountryInputChange = (inputValue) => setSearchTerm(inputValue);

  return (
    <section className="space-y-6 flex-1">
      <div className="grid gap-6 md:grid-cols-2">
        <div className="form-group">
          <label>
            Company Name <span>*</span>
          </label>
          <input
            type="text"
            name="companyName"
            placeholder="Enter company name"
            value={values.companyName}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.companyName && touched.companyName ? "error" : ""}
          />
          {errors.companyName && touched.companyName && (
            <div className="error-message">{errors.companyName}</div>
          )}
        </div>

        <div className="form-group">
          <label>
            Industry <span>*</span>
          </label>
          <Select
            name="industry"
            options={industries}
            placeholder="Select industry"
            isClearable={false}
            isSearchable={false}
            value={values.industry}
            onChange={(option) => setFieldValue("industry", option)}
            onBlur={handleBlur}
            className={
              errors.industry && touched.industry ? "error-select" : ""
            }
          />
          {errors.industry && touched.industry && (
            <div className="error-message">{errors.industry}</div>
          )}
        </div>

        <div className="form-group">
          <label>
            Company Email <span>*</span>
          </label>
          <input
            type="email"
            name="companyEmail"
            placeholder="company@example.com"
            value={values.companyEmail}
            onChange={handleChange}
            onBlur={handleBlur}
            className={
              errors.companyEmail && touched.companyEmail ? "error" : ""
            }
          />
          {errors.companyEmail && touched.companyEmail && (
            <div className="error-message">{errors.companyEmail}</div>
          )}
        </div>

        <div className="form-group">
          <label>
            Phone Number <span>*</span>
          </label>
          <input
            type="tel"
            name="phoneNumber"
            placeholder="+44-736-837"
            value={values.phoneNumber}
            onChange={(e) => {
              // Allow only numbers and limit to 10 digits
              const value = e.target.value.replace(/\D/g, "").slice(0, 10);
              setFieldValue("phoneNumber", value);
            }}
            onBlur={handleBlur}
            className={errors.phoneNumber && touched.phoneNumber ? "error" : ""}
          />
          {errors.phoneNumber && touched.phoneNumber && (
            <div className="error-message">{errors.phoneNumber}</div>
          )}
        </div>

        <div className="form-group">
          <label>
            Number of employees <span>*</span>
          </label>
          <input
            type="number"
            name="employeesCount"
            placeholder="e.g. 120"
            value={values.employeesCount}
            onChange={handleChange}
            onBlur={handleBlur}
            className={
              errors.employeesCount && touched.employeesCount ? "error" : ""
            }
          />
          {errors.employeesCount && touched.employeesCount && (
            <div className="error-message">{errors.employeesCount}</div>
          )}
        </div>

        <div className="form-group">
          <label>
            Country <span>*</span>
          </label>
          <Select
            name="country"
            options={countryOptions}
            value={
              countryOptions.find((option) => option.value == values.country) ||
              null
            } // object for React Select
            onChange={(option) => setFieldValue("country", option?.value || "")} // store only id
            onBlur={handleBlur}
            onInputChange={handleCountryInputChange}
            isLoading={countriesLoader}
            placeholder="Select Country"
            isClearable={false}
            isSearchable={true}
            className={errors.country && touched.country ? "error-select" : ""}
          />
          {errors.country && touched.country && (
            <div className="error-message">{errors.country}</div>
          )}
        </div>

        <div className="form-group md:col-span-2">
          <label>Company Address</label>
          <textarea
            name="companyAddress"
            rows={1}
            placeholder="Enter company Address"
            value={values.companyAddress}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;
